import React from 'react';
import { Button, Typography, Stack, Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useNavigate } from 'react-router';

export default function TerminalList(props) {
  const Navigate = useNavigate();
  const Datatable = props.TryData;

  const sanitize = (value) => {
    return value === undefined || value === null || value === '' ? null : value;
  };
  function formatDateTime(dateString) {
    const date = new Date(dateString);

    // Get the day, month, and year
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    return `${formattedDate}`;
  }

  return (
    <div>
      {Datatable.length > 0 ? (
        <Paper sx={{ width: '100%' }}>
          <TableContainer sx={{ maxHeight: 500, width: 1100 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Agent Name</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Agent Code</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>CSP Code</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Bank Name</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Connectivity Type</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Terminal Id</TableCell>
                  <TableCell sx={{ width: 100, color: '#592375' }}>Terminal Mapping Date</TableCell>
                  <TableCell sx={{ width: 50, color: '#592375' }}>Action</TableCell>
                  {/* <TableCell sx={{width:130}}>Resend Link</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {Datatable &&
                  Datatable
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                          <TableCell>{row.agent_name ? row.agent_name : '-'}</TableCell>
                          <TableCell>{row.agent_code ? row.agent_code : '-'}</TableCell>
                          <TableCell sx={{ alignItems: 'center' }}>
                            {row.terminal_mapped_data && row.terminal_mapped_data.csp_code ? row.terminal_mapped_data.csp_code : '-'}
                          </TableCell>
                          <TableCell>{row.bank_name || '-'}</TableCell>
                          <TableCell>
                            {row.terminal_mapped_data && row.terminal_mapped_data.connectivity_type
                              ? row.terminal_mapped_data.connectivity_type
                              : '-'}
                          </TableCell>
                          <TableCell>
                            {row.terminal_mapped_data && row.terminal_mapped_data.terminal_id ? row.terminal_mapped_data.terminal_id : '-'}
                          </TableCell>
                          <TableCell>
                            {/* {row.terminal_mapped_data ? formatDateTime(row.terminal_mapped_data.terminal_mapping_date) : '-'} */}
                            {row.terminal_mapped_data && row.terminal_mapped_data.terminal_mapping_date
                              ? formatDateTime(row.terminal_mapped_data.terminal_mapping_date)
                              : '-'}
                          </TableCell>

                          <TableCell sx={{ cursor: 'pointer' }}>
                            {/* <Box
                            sx={{
                              color: 'action.active',
                              display: 'flex',
                              flexDirection: 'column',
                              '& > *': {
                                marginBottom: 2
                              },
                              '& .MuiBadge-root': {
                                marginRight: 4
                              }
                            }}
                          >*/}
                            {/* <ButtonGroup sx={{ marginBottom: '0px' }}> */}
                            <Button
                              aria-label="increase"
                              onClick={() =>
                                Navigate('/Admin/Terminal_mapping_details', {
                                  state: {
                                    terminal_id: row.terminal_mapped_data && sanitize(row.terminal_mapped_data.terminal_id),
                                    id: row._id,
                                    code: row.terminal_mapped_data && sanitize(row.terminal_mapped_data.csp_code),
                                    map_date: row.terminal_mapped_data && sanitize(row.terminal_mapped_data.terminal_mapping_date),
                                    fingerprint_date:
                                      row.terminal_mapped_data && sanitize(row.terminal_mapped_data.finger_print_capture_date),
                                    type: row.terminal_mapped_data && sanitize(row.terminal_mapped_data.connectivity_type)
                                  }
                                })
                              }
                              size="small"
                            >
                              {/* <AddIcon fontSize="small" /> */}
                              {/* Add */}
                              <EditOutlinedIcon sx={{ marginRight: '5px', color: '#2196f3' }} />
                            </Button>
                            {/* <Button aria-label="reduce" onClick={() => handleDelete(row._id, row.terminal_mapped_data.terminal_id)}>
                              <DeleteIcon sx={{ color: '#f44336' }} />
                            </Button> */}
                            {/* </ButtonGroup> */}
                            {/* </Box> */}
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            sx={{ width: '100%' }}
            rowsPerPageOptions={[10, 50, 100]}
            component="div"
            count={props.TotalCountTer}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            onPageChange={props.handleChangePage}
            onRowsPerPageChange={props.handleChangeRowsPerPage}
          />
        </Paper>
      ) : (
        <Grid item xl={12} mt={5}>
          <Stack justifyContent="center" alignItems="center">
            <Typography mt={1} variant="h5">
              No data found
            </Typography>
          </Stack>
        </Grid>
      )}
    </div>
  );
}
